import React from 'react'
import styled from 'styled-components'

interface ResponsiveImageProps {
  src: string
  alt: string
  maxWidth?: string | number
  aspectRatio?: string
  objectFit?: React.CSSProperties['objectFit']
  borderRadius?: string
  style?: React.CSSProperties
  className?: string
}

const StyledImage = styled.img<{
  $maxWidth: string
  $aspectRatio: string
  $objectFit: string
  $borderRadius: string
}>`
  display: block;
  width: 100%;
  max-width: ${(props) => props.$maxWidth};
  aspect-ratio: ${(props) => props.$aspectRatio};
  object-fit: ${(props) => props.$objectFit};
  border-radius: ${(props) => props.$borderRadius};
`

export function ResponsiveImage({
  src,
  alt,
  maxWidth = '100%',
  aspectRatio = 'auto',
  objectFit = 'cover',
  borderRadius,
  style,
  className,
}: ResponsiveImageProps) {
  const resolvedBorderRadius = borderRadius ?? '8px'
  const resolvedMaxWidth =
    typeof maxWidth === 'number' ? `${maxWidth}px` : maxWidth

  return (
    <StyledImage
      src={src}
      alt={alt}
      $maxWidth={resolvedMaxWidth}
      $aspectRatio={aspectRatio}
      $objectFit={objectFit}
      $borderRadius={resolvedBorderRadius}
      style={style}
      className={className}
    />
  )
}
